import React from 'react'
import type { PresentationBlockProps } from '../../'
import compareBlockProps from '../../util/compareBlockProps'

import CardsBlock from '../Cards/CardsBlock'

function TestimonialsBlock(props: PresentationBlockProps) {
  return <CardsBlock type={'testimonials'} {...props} />
}

export default React.memo(TestimonialsBlock, (prevProps, nextProps) => {
  return compareBlockProps(prevProps, nextProps)
})
